import React, { useState } from "react";
import { tableService } from "../../services/tableService";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Button,
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Input,
  TextareaComponent,
} from "../ui";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";

const TableForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [formData, setFormData] = useState({
    restoId: "",
    mesaId: "",
    descriptionMesa: "",
    ubication: "",
    cantAsientos: "",
    joinTable: "NO",
    tableStatus: "CREADA",
    isVirtualTable: "NO",
    cartData: [],
    isEnabled: "SI",
    joinTablesId: {},
  });

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const validateForm = () => {
    const requiredFields = {
      mesaId: "ID de mesa",
      ubication: "Ubicación",
      cantAsientos: "Cantidad de asientos",
    };

    const missingFields = Object.entries(requiredFields)
      .filter(([key]) => !formData[key])
      .map(([, label]) => label);

    if (missingFields.length > 0) {
      toast.error(`Por favor complete los campos: ${missingFields.join(", ")}`);
      return false;
    }

    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setShowConfirmDialog(true);
  };

  const handleConfirm = async () => {
    setShowConfirmDialog(false);
    setLoading(true);
    try {
      const result = await tableService.registerTable({
        ...formData,
        descriptionMesa: formData.descriptionMesa.trim(), // Aseguramos que se envíe el valor limpio
      });
      if (result.success) {
        toast.success(result.message);
        setFormData({
          restoId: "",
          mesaId: "",
          descriptionMesa: "",
          ubication: "",
          cantAsientos: "",
          joinTable: "NO",
          tableStatus: "CREADA",
          isVirtualTable: "NO",
          cartData: [],
          isEnabled: "SI",
          joinTablesId: {},
        });
        handleRedirection("/dashboard/mostrarMesas");
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error(error.message || "Error al registrar la mesa");
    } finally {
      setLoading(false);
    }
  };

  const handleRedirection = (path) => {
    setShowConfirmDialog(false);
    navigate(path);
  };

  return (
    <div className="p-4 md:p-6 max-w-2xl mx-auto">
      <Card className="w-full">
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-center">
            Agregar Mesa
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          {/* RestoId */}
          <div className="space-y-2">
            <label className="text-sm font-medium">ID del Restaurante</label>
            <Input
              placeholder="ID del restaurante"
              value={formData.restoId}
              onChange={(e) => handleInputChange("restoId", e.target.value)}
              className="border-orange-200 focus:border-orange-500"
            />
          </div>

          {/* Identificador */}
          <div className="space-y-2">
            <label className="text-sm font-medium">
              Identificador de la Mesa *
            </label>
            <Input
              placeholder="Identificador del Sistema"
              value={formData.mesaId}
              onChange={(e) => handleInputChange("mesaId", e.target.value)}
              className="border-orange-200 focus:border-orange-500"
            />
          </div>

          {/* Descripción */}
          <div className="space-y-2">
            <label className="text-sm font-medium">
              Nombre de la Mesa (se identificara por el Camarero)
            </label>
            <textarea
              placeholder="TERRAZA 6"
              value={formData.descriptionMesa}
              onChange={(e) => {
                const value = e.target.value;
                setFormData((prev) => ({
                  ...prev,
                  descriptionMesa: value,
                }));
              }}
              className="w-full px-3 py-2 border rounded-md min-h-[100px] border-orange-200 focus:border-orange-500"
            />
          </div>

          {/* Resto del formulario sin cambios */}
          {/* Ubicación */}
          <div className="space-y-2">
            <label className="text-sm font-medium">Ubicación *</label>
            <Select
              value={formData.ubication}
              onValueChange={(value) => handleInputChange("ubication", value)}
            >
              <SelectTrigger className="border-orange-200">
                <SelectValue placeholder="Seleccione ubicación" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Interior">Interior</SelectItem>
                <SelectItem value="Exterior">Exterior</SelectItem>
                <SelectItem value="Terraza">Terraza</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {/* Cantidad de asientos */}
          <div className="space-y-2">
            <label className="text-sm font-medium">
              Cantidad de asientos *
            </label>
            <Select
              value={formData.cantAsientos}
              onValueChange={(value) =>
                handleInputChange("cantAsientos", value)
              }
            >
              <SelectTrigger className="border-orange-200">
                <SelectValue placeholder="Seleccione cantidad" />
              </SelectTrigger>
              <SelectContent>
                {[2, 4, 6, 8].map((num) => (
                  <SelectItem key={num} value={num.toString()}>
                    {num}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          {/* ¿Se puede unir? */}
          <div className="space-y-2">
            <label className="text-sm font-medium">¿Se puede unir?</label>
            <Select
              value={formData.joinTable}
              onValueChange={(value) => handleInputChange("joinTable", value)}
            >
              <SelectTrigger className="border-orange-200">
                <SelectValue placeholder="¿Se puede unir?" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="SI">Sí</SelectItem>
                <SelectItem value="NO">No</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {/* Mesa Virtual */}
          <div className="space-y-2">
            <label className="text-sm font-medium">¿Es mesa virtual?</label>
            <Select
              value={formData.isVirtualTable}
              onValueChange={(value) =>
                handleInputChange("isVirtualTable", value)
              }
            >
              <SelectTrigger className="border-orange-200">
                <SelectValue placeholder="¿Es virtual?" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="SI">Sí</SelectItem>
                <SelectItem value="NO">No</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {/* Estado de habilitación */}
          <div className="space-y-2">
            <label className="text-sm font-medium">
              Estado de habilitación
            </label>
            <Select
              value={formData.isEnabled}
              onValueChange={(value) => handleInputChange("isEnabled", value)}
            >
              <SelectTrigger className="border-orange-200">
                <SelectValue placeholder="Estado de habilitación" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="SI">Habilitada</SelectItem>
                <SelectItem value="NO">Deshabilitada</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <Button
            className="w-full bg-orange-500 hover:bg-orange-600 text-white"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Agregando..." : "Agregar"}
          </Button>
        </CardContent>
      </Card>

      <AlertDialog open={showConfirmDialog} onOpenChange={setShowConfirmDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>¿Confirmar registro?</AlertDialogTitle>
            <AlertDialogDescription>
              ¿Está seguro que desea registrar esta mesa?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={handleConfirm}>
              Confirmar
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default TableForm;
